import React from 'react';
import IconsButton from './IconsButton';

export interface IDeleteButtonProps {
    /** Accessible label (visually hidden) for the delete action. */
    children: React.ReactNode;
    disabled?: boolean;
    onClick?: (
        event:
            | React.MouseEvent<HTMLButtonElement>
            | React.KeyboardEvent<HTMLButtonElement>
            | React.TouchEvent<HTMLButtonElement>
    ) => void;
}

/** Round, borderless destructive icon button (error-red, red-fill on hover). */
function DeleteIconButton({ children, disabled, onClick }: IDeleteButtonProps) {
    return (
        <IconsButton
            label={typeof children === 'string' ? children : ''}
            startIcon="delete"
            $color="danger"
            circle
            hideBorder
            disabled={disabled}
            onClick={onClick}
        />
    );
}

export default DeleteIconButton;
